import { categories } from '@/mocks/categories';

const CARD_IMAGES = [
  "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20luxury%20designer%20sneakers%20on%20a%20polished%20concrete%20surface%2C%20dramatic%20side%20lighting%20from%20a%20large%20window%2C%20warm%20sand-colored%20wall%20background%2C%20minimalist%20composition%20with%20strong%20shadows%2C%20high-end%20boutique%20aesthetic%2C%20cream%20and%20beige%20tones&width=600&height=800&seq=cat-shoes-v2-2026x&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Cozy%20premium%20cashmere%20sweater%20draped%20over%20a%20vintage%20wooden%20chair%20near%20a%20sunlit%20window%2C%20soft%20morning%20light%20filtering%20through%20linen%20curtains%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20editorial%20lifestyle%20photography%2C%20peaceful%20home%20atmosphere&width=600&height=800&seq=cat-hoodies-v2-2026x&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20t-shirts%20in%20olive%20green%20and%20sand%20colors%20neatly%20stacked%20on%20a%20light%20wooden%20shelf%2C%20bright%20natural%20daylight%2C%20minimalist%20Scandinavian%20interior%20style%2C%20clean%20lines%20and%20simple%20composition%2C%20earthy%20warm%20aesthetic&width=600&height=800&seq=cat-tshirts-v2-2026x&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Designer%20leather%20jacket%20and%20wool%20coat%20displayed%20on%20minimalist%20black%20metal%20racks%20in%20a%20bright%20white%20studio%2C%20soft%20overhead%20lighting%2C%20modern%20boutique%20display%20aesthetic%2C%20clean%20professional%20product%20photography%2C%20warm%20neutral%20accents&width=600&height=800&seq=cat-jackets-v2-2026x&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Luxury%20watches%20and%20leather%20bracelets%20arranged%20on%20a%20warm%20travertine%20stone%20surface%2C%20natural%20sunlight%20creating%20soft%20highlights%2C%20elegant%20magazine-style%20flat%20lay%20composition%2C%20sophisticated%20neutral%20palette%2C%20refined%20editorial%20aesthetic&width=600&height=800&seq=cat-accessories-v2-2026x&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Premium%20canvas%20and%20leather%20backpacks%20leaning%20against%20a%20textured%20cream%20wall%20with%20dried%20pampas%20grass%20nearby%2C%20golden%20hour%20sunlight%20casting%20long%20shadows%2C%20boho%20luxury%20aesthetic%2C%20warm%20earth%20tone%20photography&width=600&height=800&seq=cat-bags-v2-2026x&orientation=portrait",
];

const FEATURED_INDEXES = [0, 1, 3, 5, 8, 10];

export default function CategoryGrid() {
  const featuredCategories = FEATURED_INDEXES.map((idx, i) => ({
    ...categories[idx],
    image: CARD_IMAGES[i],
  }));

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-10">
        <div className="mb-12 md:mb-16">
          <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">Shop by Category</p>
          <h2 className="text-foreground-950 text-3xl md:text-[2.75rem] font-heading font-bold leading-tight">
            Explore Our Product <span className="italic font-light">Collections</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              data-product-shop
              className="group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-[1.02]"
              style={{ aspectRatio: '3/4', minHeight: '360px' }}
            >
              <img
                src={cat.image}
                alt={`${cat.name} collection`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-white text-xl md:text-2xl font-heading font-semibold mb-1.5">{cat.name}</h3>
                <p className="text-white/80 text-sm leading-relaxed max-w-[280px]">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={() => {
              const el = document.querySelector('[data-category-dropdown]') as HTMLButtonElement;
              if (el) {
                el.click();
              } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                  const hamburger = document.querySelector('[aria-label="Open menu"]') as HTMLButtonElement;
                  if (hamburger) hamburger.click();
                }, 400);
              }
            }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 text-sm font-semibold cursor-pointer hover:border-foreground-950 hover:text-foreground-950 transition-all whitespace-nowrap"
          >
            View All 14 Categories
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>
      </div>
    </section>
  );
}